import { IDS } from '../../settings-action-id.constants';
import { TAB_SELECT, TAB_SHOW } from '../../../../../common/tabs/tabs.constants'
import * as AccreditationActions from '../../../accreditation.actions';
import * as SettingsActions from "../../settings.actions";
import * as Actions from '../slo-required-docs.actions';
import {TYPES} from "../../settings-action-type.constants";
import {GRID_RELOAD} from "../../../../../common/grid/grid.constants";
import get from "lodash/get";

/**
 * Creates a new SloRequiredDocDetailsController.
 * @class
 */
export const sloRequiredDocDetails = {
    /* @ngInject */
    controller: function ($ngRedux, $state, $stateParams, $scope, $rootScope, $filter, NavigationService, AuthService, Notifier, FileActions) {
        /**
         * @function $onInit
         */
        this.$onInit = async () => {
            this.identifier = `${IDS.accSettings}.${IDS.sloRequiredDocDetails}`;
            this.parentState = IDS.app_accreditation_scheme_settings_slo_required_docs;

            this.unsubscribe = $ngRedux.connect(state => {
                const accSettings = state.accreditation.accSettings;

                const document = accSettings.sloRequiredDocDetails;

                const textId = `COMMON.DOCUMENT.CODE.${document?.type_code.toUpperCase()}`;
                let typeName = $filter('translate')(textId);
                if (typeName === textId)
                    typeName = document.type_name;

                return {
                    sectionsTree:               state.accreditation.simpleSectionsTree,
                    typeName,
                    document,
                    schemeName:                 accSettings.frameworkDetails.title,
                    sample_doc_uri:             accSettings.sloRequiredDocDetails.sample_doc_uri,
                    assignedRequirements:           accSettings.sloRequiredDocSectionsGrid.items,
                }
            }, {
                ...AccreditationActions,
                ...FileActions,
                ...SettingsActions,
                ...Actions,
            })(this);

            this.title = `${this.document.name}`;
            this.schemeCode = $stateParams.itemCode;


            this.getRegulatoryFrameworkDetails(this.schemeCode).then(scheme => {
                this.fetchEnabledHeadOffices(scheme.id)
            })
            this.initSectionsInputSelects({})
        }

        this.initSectionsInputSelects = ({deselectAll}) => {
            // insert sections to first section select box
            $ngRedux.dispatch({
                type: TYPES.SELECT_CASCADE_SECTIONS,
                id: this.identifier,
                level:0,
                sections: this.sectionsTree,
                sectionId: null,
                sectionParentId: null,
            });

            let selectedLevel1Id, selectedLevel2Id, selectedLevel3Id;
            if(this.sectionId && this.sectionParentId && this.sectionSchemeCode === this.schemeCode){
                const section2 = this.findChildSectionById(this.sectionParentId, this.sectionsTree);
                selectedLevel1Id = section2.sectionParentId;
                selectedLevel2Id = this.sectionParentId;
                selectedLevel3Id = this.sectionId;
            }
            else{
                selectedLevel1Id = get(this.sectionsTree,'[0].id');
                selectedLevel2Id = get(this.sectionsTree,'[0].children[0].id');
                selectedLevel3Id = get(this.sectionsTree,'[0].children[0].children[0].id');
            }

            if(selectedLevel1Id) this.onSelectRequirement({item:{value: selectedLevel1Id}, skipGridFetch: true, deselectAll});
            if(selectedLevel2Id) this.onSelectRequirement({item:{value: selectedLevel2Id}, skipGridFetch: true, deselectAll});
            let level3Section;
            if(selectedLevel3Id)
                level3Section = this.onSelectRequirement({item:{value: selectedLevel3Id}, skipGridFetch: !!deselectAll, deselectAll});

            if(level3Section && deselectAll === false){
                this.getFrameworkRequirementDetails({
                    ...level3Section,
                    schemeCode: this.schemeCode
                });
            }
            if(deselectAll)
                $ngRedux.dispatch({
                    type:   TYPES.SELECT_CASCADE_SECTIONS_RESET,
                    id:     this.identifier,
                });
        }

        this.onSelectRequirement = ({item, skipGridFetch = undefined, deselectAll = false}) =>{
            const section = this.findChildSectionById(item.value, this.sectionsTree);
            const level3Requirements = section.level === 1 && section.children.length
                ? this.findChildSectionById(section.children[0].id, this.sectionsTree).children
                : undefined;
            $ngRedux.dispatch({
                type:       TYPES.SELECT_CASCADE_SECTIONS,
                id:         this.identifier,
                sectionId: section.id,
                level:      section.level,
                sections:  section.children,
                level3Requirements,
                schemeCode: this.schemeCode
            });

            const level3Section =
                level3Requirements?.length && level3Requirements[0]
                || section.children?.length && section.children[0]
                || section;

            if(deselectAll === false) {
                this.selectedRequirement = level3Section.id
            }
            return level3Section
        }

        this.findChildSectionById = (id, sections) => {
            return sections.reduce((result, item) => {
                if(result)
                    return result;
                if(item.id === id)
                    return item
                else if (item.children.length)
                    return this.findChildSectionById(id, item.children)
            }, null);
        }

        this.onButtonDetachReqDocFromSection = ({item}) => {
            //verify that section is not last remaining section
            if (this.assignedRequirements.length === 1) {
                return
            }
            this.detachEvidenceGroupFromRequirement(this.document.ard_id, item.id, IDS.sloRequiredDocSectionsGrid).then(() => {
                $ngRedux.dispatch({
                    type: GRID_RELOAD,
                    id: IDS.accSettings,
                    path: IDS.sloRequiredDocsGrid,
                })
            });
        }

        this.onButtonAssignReqDocToSection = () => {
            //verify that section is not already added
            if (this.assignedRequirements.find(item => item.id === this.selectedRequirement)) {
                return
            }
            this.assignEvidenceGroupToFrameworkRequirement(this.document.ard_id, this.selectedRequirement, IDS.sloRequiredDocSectionsGrid).then(() => {
                $ngRedux.dispatch({
                    type: GRID_RELOAD,
                    id: IDS.accSettings,
                    path: IDS.sloRequiredDocsGrid,
                })
            });
        }

        this.onSampleDocUploadSave = (event) => {
            $ngRedux.dispatch({
                type: TYPES.DOCUMENT_SAMPLE_DOC_CHANGED,
                id: IDS.accSettings,
                path: IDS.sloRequiredDocDetails,
                sample_doc_uri: event[0].filePath,
            });
        }

        this.onDownloadSampleDoc = () => {
            this.download(`storage${this.sample_doc_uri}`);
        };

        this.onResetSampleDoc = () => {
            $ngRedux.dispatch({
                type: TYPES.DOCUMENT_SAMPLE_DOC_CHANGED,
                id: IDS.accSettings,
                path: IDS.sloRequiredDocDetails,
                sample_doc_uri: null,
            });
        }

        this.onSaveChangesButton = () => {
            $scope.$broadcast('show-errors-check-validity', '$ctrl.requiredDocumentDetailsForm');

            if (this.requiredDocumentDetailsForm.$valid === false) {
                Notifier.error('COMMON.FIELDS_REQUIRED');
                return;
            }
            this.editSloEvidenceGroup({
                ard_id: this.document.ard_id,
                doc_num: this.document.doc_num,
                name: this.document.name,
                description: this.document.description,
                sample_doc_uri: this.document.sample_doc_uri,
            }).then(() => {
                $ngRedux.dispatch({
                    type: TAB_SELECT,
                    id: this.parentState,
                    state: IDS.app_accreditation_scheme_settings_slo_required_docs_list,
                });

            })
        }

        this.$onDestroy = () => {
            this.unsubscribe();
        }
    },
    template: require('./slo-required-doc-details.html')
}